import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { IOutletsMapConfig, IOutletDelivery, IScheduleOverride, OUTLET_SCHEDULE_TYPES, UiContextService } from '@cakeiteasy/web-utils';

@Component({
  standalone: false,
  selector: 'stores-map-modal',
  styleUrls: ['./stores-map-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  host: { class: 'stores-map-modal' },
  template: `
    <i class="icon-close font-xl stores-map-close cursor-pointer" (click)="modal.dismiss()"> </i>

    <div class="modal-body position-relative">
      @if (uiContext.isSm()) {
        <ui-outlets-map-mobile
          class="outlets-map-modal-wrap"
          [outlets]="outlets"
          [scheduleOverridesByOutletId]="scheduleOverridesByOutletId"
          [disabledOutletIds]="disabledOutletIds"
          [nextText]="'modal.outletsMap.pickUpHereBtn' | translate"
          [showNext]="true"
          [isOutletSelectionStateEnabled]="config.isOutletSelectionStateEnabled"
          [scheduleType]="config.scheduleType"
          [outletAccordionOptions]="config.outletAccordionOptions"
          (onNext)="modal.close($event)"
          (onOutletChanged)="onOutletChanged($event)"
        ></ui-outlets-map-mobile>
      } @else {
        <div class="font-2xl fw-super-bold text-center pt-3 pb-4" [translate]="'modal.outletsMap.title'">
          Where do you want to pick it up?
        </div>

        <ui-map-with-outlets-accordion
          class="outlets-map-modal-wrap"
          [outlets]="outlets"
          [scheduleOverridesByOutletId]="scheduleOverridesByOutletId"
          [disabledOutletIds]="disabledOutletIds"
          [shiftMapToRight]="true"
          [nextText]="'modal.outletsMap.pickUpHereBtn' | translate"
          [showNext]="true"
          [isOutletSelectionStateEnabled]="config.isOutletSelectionStateEnabled"
          [scheduleType]="config.scheduleType"
          [outletAccordionOptions]="config.outletAccordionOptions"
          (onNext)="modal.close($event)"
          (onOutletChanged)="onOutletChanged($event)"
        ></ui-map-with-outlets-accordion>
      }
    </div>
  `,
})
export class StoresMapModalComponent implements OnInit {
  @Input() outlets: IOutletDelivery[];
  @Input() loadScheduleOverrides: (outlet: IOutletDelivery) => Promise<IScheduleOverride[]>;
  @Input() disabledOutlets: IOutletDelivery[] = [];
  @Input() config: IOutletsMapConfig;

  disabledOutletIds: number[] = [];
  public scheduleOverridesByOutletId: { [outletId: number]: IScheduleOverride[] } = {};

  public defaultConfig = {
    isOutletSelectionStateEnabled: true,
    scheduleType: OUTLET_SCHEDULE_TYPES.WORKING_DAYS,
  };

  constructor(
    public uiContext: UiContextService,
    public modal: NgbActiveModal,
  ) {}

  ngOnInit() {
    this.config = { ...this.defaultConfig, ...this.config };
    this.disabledOutletIds = this.disabledOutlets.map(({ id }) => id);
  }

  public onOutletChanged(outlet: IOutletDelivery): void {
    const scheduleOverridesByOutletId = this.scheduleOverridesByOutletId || {};

    if (!outlet || !this.loadScheduleOverrides || scheduleOverridesByOutletId[outlet.id]) {
      return;
    }

    this.loadScheduleOverrides(outlet).then((scheduleOverrides = []) => {
      this.scheduleOverridesByOutletId = {
        ...(this.scheduleOverridesByOutletId || {}),
        [outlet.id]: scheduleOverrides,
      };
    });
  }
}
